<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid>
      <div class="d-flex mb-4">
        <h2>{{ $t("My Equipment") }}</h2>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          dark
          height="40px"
          small
          @click="showRegisterEquiptment = true"
        >
          {{ $t("inventoryObj.addNewEquipment") }}
        </v-btn>
      </div>
      <v-card elevation="0" class="px-5 custom-comp" id="userlist">
        <v-card-text>
          <template>
            <v-tabs v-model="tab">
              <v-tab @click="equipmentType = 'Single'">
                {{ $t("inventoryObj.singleEquipment") }}
              </v-tab>
              <v-tab @click="equipmentType = 'Group'">
                {{ $t("inventoryObj.setOfEquipment") }}
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
              <v-tab-item>
                <div
                  class="text-center"
                  v-if="equipments && equipments.count === 0 && search === ''"
                >
                  <v-row justify="center" align="center">
                    <v-col cols="12" sm="4">
                      <div class="py-16">
                        <img src="/img/Notes.svg" /><br />
                        <strong>{{
                          $t("inventoryObj.noEquipmentFound")
                        }}</strong
                        ><br />
                        <div class="py-4">
                          <small
                            >{{ $t("inventoryObj.equipmentMsg1") }}<br />
                            {{ $t("inventoryObj.equipmentMsg2") }}</small
                          >
                        </div>
                        <v-btn
                          color="primary"
                          dark
                          to="equipmentRegistration/singleEquipment"
                        >
                          {{ $t("inventoryObj.addNewEquipment") }}
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </div>
                <v-card elevation="10" v-else>
                  <div ref="document">
                    <v-card-text>
                      <v-data-table
                        :headers="tableHeaders"
                        :items="equipments && equipments.rows"
                        item-key="id"
                        :items-per-page="10"
                        :loading="loading"
                        :hide-default-footer="true"
                        :options.sync="tableOptions"
                        :server-items-length="
                          equipments && equipments.totalCount
                        "
                      >
                        <template v-slot:top>
                          <div class="d-flex mt-5">
                            <v-text-field
                              prepend-inner-icon="mdi-magnify"
                              outlined
                              height="5px"
                              placeholder="Search"
                              dense
                              v-model="search"
                              class="shrink"
                            ></v-text-field>
                            <v-spacer></v-spacer>
                            <div class="py-1 title">
                              {{ from }} - {{ to }} of {{ totalEquipments }}
                            </div>
                            <v-btn
                              class="mx-2"
                              fab
                              small
                              outlined
                              color="primary"
                              :disabled="tableOptions.page <= 1"
                              @click="pageChange(false)"
                            >
                              <v-icon dark> mdi-chevron-left </v-icon>
                            </v-btn>
                            <v-btn
                              class="mx-2"
                              fab
                              small
                              outlined
                              color="primary"
                              :disabled="tableOptions.page >= totalPages"
                              @click="pageChange(true)"
                            >
                              <v-icon dark> mdi-chevron-right </v-icon>
                            </v-btn>

                            <v-menu
                              v-model="document"
                              :close-on-content-click="false"
                              :nudge-width="200"
                              left
                              :min-width="417"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  class="mx-2"
                                  fab
                                  small
                                  outlined
                                  color="primary"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  <v-icon dark> mdi-cog-outline </v-icon>
                                </v-btn>
                              </template>

                              <v-card width="417">
                                <v-list>
                                  <v-list-item>
                                    <v-list-item-content>
                                      <v-list-item-title>{{
                                        $t("customization")
                                      }}</v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                  <v-divider></v-divider>
                                  <div class="pl-3 pt-2 font-weight-normal">
                                    {{ $t("recordsPerPage") }}
                                  </div>
                                  <v-list-item>
                                    <v-list-item-content>
                                      <v-slider
                                        v-model="itemsPerPageSlider"
                                        :tick-labels="itemsPerPageOptions"
                                        :max="3"
                                        step="1"
                                        ticks="always"
                                        tick-size="4"
                                      ></v-slider>
                                    </v-list-item-content>
                                  </v-list-item>
                                  <v-divider class="mt-n3"></v-divider>
                                </v-list>
                                <v-card-text>
                                  <v-container fluid>
                                    <v-row>
                                      <v-col
                                        class="mt-n9"
                                        cols="6"
                                        v-for="header in headers"
                                        :key="header.value"
                                      >
                                        <v-checkbox
                                          v-model="selectedHeaders"
                                          :label="header.text"
                                          color="primary"
                                          :value="header.text"
                                          hide-details
                                          :disabled="
                                            header.text == 'ID' ||
                                            header.text == 'Tag'
                                          "
                                        ></v-checkbox>
                                      </v-col>
                                    </v-row>
                                  </v-container>
                                </v-card-text>
                                <v-layout justify-center>
                                  <v-card-actions class="mb-5">
                                    <v-spacer></v-spacer>

                                    <v-btn
                                      outlined
                                      color="primary"
                                      @click="resetDefaut"
                                      width="190"
                                    >
                                      {{ $t("restoreDefault") }}
                                    </v-btn>
                                    <v-btn
                                      color="primary"
                                      @click="resetTableStructure"
                                      width="190"
                                    >
                                      {{ $t("apply") }}
                                    </v-btn>
                                  </v-card-actions>
                                </v-layout>
                              </v-card>
                            </v-menu>

                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  class="mx-2"
                                  fab
                                  small
                                  outlined
                                  color="primary"
                                  v-bind="attrs"
                                  v-on="on"
                                  @click="exportToPDF('document')"
                                >
                                  <v-img src="/icons/download.svg"></v-img>
                                </v-btn>
                              </template>

                              <span>Download</span>
                            </v-tooltip>
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  class="mx-2"
                                  fab
                                  small
                                  outlined
                                  color="primary"
                                  v-bind="attrs"
                                  v-on="on"
                                  @click="printPDF('document')"
                                >
                                  <v-icon dark> mdi-printer </v-icon>
                                </v-btn>
                              </template>
                              <span>Print</span>
                            </v-tooltip>
                          </div>
                        </template>
                        <template
                          v-slot:item.actions="{ item }"
                          data-html2canvas-ignore="true"
                        >
                          <v-icon
                            small
                            class="mr-2"
                            @click="editEquipment(item)"
                          >
                            mdi-pencil
                          </v-icon>
                          <v-icon
                            small
                            @click="
                              () => {
                                selectedItem = item;
                                showDeleteEquipmentDialog = true;
                              }
                            "
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                        <template v-slot:item.userFarmData="{ item }">
                          {{
                            item.userFarmData.length > 0
                              ? item.userFarmData[0].farm_id.farmName
                              : item.userSegmentData
                                  .map(s => s.segment_id.geofenceName)
                                  .join(", ")
                          }}
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </div>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <div
                  class="text-center"
                  v-if="equipments && equipments.count === 0 && search === ''"
                >
                  <v-row justify="center" align="center">
                    <v-col cols="12" sm="4">
                      <div class="py-16">
                        <img src="/img/Notes.svg" /><br />
                        <strong>{{
                          $t("inventoryObj.noEquipmentFound")
                        }}</strong
                        ><br />
                        <div class="py-4">
                          <small
                            >{{ $t("inventoryObj.equipmentMsg1") }}<br />
                            {{ $t("inventoryObj.equipmentMsg2") }}</small
                          >
                        </div>
                        <v-btn
                          color="primary"
                          dark
                          to="equipmentRegistration/groupEquipment"
                        >
                          {{ $t("Add New Equipment") }}
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </div>
                <v-card elevation="10" v-else>
                  <div ref="documentAll">
                    <v-card-text>
                      <v-data-table
                        :headers="tableHeaders"
                        :items="equipments && equipments.rows"
                        item-key="id"
                        :items-per-page="10"
                        :loading="loading"
                        :hide-default-footer="true"
                        :options.sync="tableOptions"
                        :server-items-length="
                          equipments && equipments.totalCount
                        "
                      >
                        <template v-slot:top>
                          <div class="d-flex mt-5">
                            <v-text-field
                              prepend-inner-icon="mdi-magnify"
                              outlined
                              height="5px"
                              placeholder="Search"
                              dense
                              v-model="search"
                              class="shrink"
                            ></v-text-field>
                            <v-spacer></v-spacer>
                            <div class="py-1 title">
                              {{ from }} - {{ to }} of {{ totalEquipments }}
                            </div>
                            <v-btn
                              class="mx-2"
                              fab
                              small
                              outlined
                              color="primary"
                              :disabled="tableOptions.page <= 1"
                              @click="pageChange(false)"
                            >
                              <v-icon dark> mdi-chevron-left </v-icon>
                            </v-btn>
                            <v-btn
                              class="mx-2"
                              fab
                              small
                              outlined
                              color="primary"
                              :disabled="tableOptions.page >= totalPages"
                              @click="pageChange(true)"
                            >
                              <v-icon dark> mdi-chevron-right </v-icon>
                            </v-btn>
                            <v-menu
                              v-model="customizeMenuAll"
                              :close-on-content-click="false"
                              :nudge-width="200"
                              left
                              :min-width="417"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  class="mx-2"
                                  fab
                                  small
                                  outlined
                                  color="primary"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  <v-icon dark> mdi-cog-outline </v-icon>
                                </v-btn>
                              </template>

                              <v-card width="417">
                                <v-list>
                                  <v-list-item>
                                    <v-list-item-content>
                                      <v-list-item-title>{{
                                        $t("customization")
                                      }}</v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                  <v-divider></v-divider>
                                  <div class="pl-3 pt-2 font-weight-normal">
                                    {{ $t("recordsPerPage") }}
                                  </div>
                                  <v-list-item>
                                    <v-list-item-content>
                                      <v-slider
                                        v-model="itemsPerPageSlider"
                                        :tick-labels="itemsPerPageOptions"
                                        :max="3"
                                        step="1"
                                        ticks="always"
                                        tick-size="4"
                                      ></v-slider>
                                    </v-list-item-content>
                                  </v-list-item>
                                  <v-divider class="mt-n3"></v-divider>
                                </v-list>
                                <v-card-text>
                                  <v-container fluid>
                                    <v-row>
                                      <v-col
                                        class="mt-n9"
                                        cols="6"
                                        v-for="header in headers"
                                        :key="header.value"
                                      >
                                        <v-checkbox
                                          v-model="selectedHeaders"
                                          :label="header.text"
                                          color="primary"
                                          :value="header.text"
                                          hide-details
                                          :disabled="
                                            header.text == 'ID' ||
                                            header.text == 'Tag'
                                          "
                                        ></v-checkbox>
                                      </v-col>
                                    </v-row>
                                  </v-container>
                                </v-card-text>
                                <v-layout justify-center>
                                  <v-card-actions class="mb-5">
                                    <v-spacer></v-spacer>

                                    <v-btn
                                      outlined
                                      color="primary"
                                      @click="resetDefaut"
                                      width="190"
                                    >
                                      {{ $t("restoreDefault") }}
                                    </v-btn>
                                    <v-btn
                                      color="primary"
                                      @click="resetTableStructure"
                                      width="190"
                                    >
                                      {{ $t("apply") }}
                                    </v-btn>
                                  </v-card-actions>
                                </v-layout>
                              </v-card>
                            </v-menu>
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  class="mx-2"
                                  fab
                                  small
                                  outlined
                                  color="primary"
                                  v-bind="attrs"
                                  v-on="on"
                                  @click="exportToPDF('documentAll')"
                                >
                                  <v-img src="/icons/download.svg"></v-img>
                                </v-btn>
                              </template>

                              <span>{{ $t("inventoryObj.download") }}</span>
                            </v-tooltip>
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  class="mx-2"
                                  fab
                                  small
                                  outlined
                                  color="primary"
                                  v-bind="attrs"
                                  v-on="on"
                                  @click="printPDF('documentAll')"
                                >
                                  <v-icon dark> mdi-printer </v-icon>
                                </v-btn>
                              </template>
                              <span>{{ $t("inventoryObj.print") }}</span>
                            </v-tooltip>
                          </div>
                        </template>
                        <template
                          v-slot:item.actions="{ item }"
                          data-html2canvas-ignore="true"
                        >
                          <v-icon
                            small
                            class="mr-2"
                            @click="editEquipment(item)"
                          >
                            mdi-pencil
                          </v-icon>
                          <v-icon
                            small
                            @click="
                              () => {
                                selectedItem = item;
                                showDeleteEquipmentDialog = true;
                              }
                            "
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                        <template v-slot:item.userFarmData="{ item }">
                          {{
                            item.userFarmData.length > 0
                              ? item.userFarmData[0].farm_id.farmName
                              : item.userSegmentData
                                  .map(s => s.segment_id.geofenceName)
                                  .join(", ")
                          }}
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </div>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </template>
        </v-card-text>
      </v-card>
    </v-container>

    <registerEquipment
      v-if="showRegisterEquiptment"
      :dialogI="showRegisterEquiptment"
      @closereqisterEquiptment="showRegisterEquiptment = false"
    >
    </registerEquipment>

    <delete-equipment-dialog
      v-if="showDeleteEquipmentDialog"
      :dialogI="showDeleteEquipmentDialog"
      @closeDeleteDialog="showDeleteEquipmentDialog = false"
      :equipmentId="selectedItem.id"
      @deleteEquipmentSuccess="onDeleteSuccess"
    />

    <v-snackbar
      v-model="snackbar.status"
      timeout="2000"
      :color="snackbar.color"
    >
      {{ snackbar.text }}
    </v-snackbar>
  </div>
</template>

<script>
import loadingMixin from "@/mixins/LoadingMixin";
import RegisterEquipment from "./RegisterEquipment";
import DeleteEquipmentDialog from "./DeleteEquipmentDialog";
import gql from "graphql-tag";
import html2pdf from "html2pdf.js";
import printJS from "print-js";

export default {
  name: "Equipments",
  data() {
    return {
      showRegisterEquiptment: false,
      tab: 0,
      from: 0,
      to: 0,
      tableOptions: {},
      totalEquipments: "",
      totalPages: "",
      search: "",
      customizeMenu: false,
      customizeMenuAll: false,
      itemsPerPageOptions: [5, 10, 25, 50],
      itemsPerPageSlider: 3,
      selectedHeaders: [],
      tableHeaders: [],
      breadcrumbs: [
        {
          text: this.$t("inventoryObj.dashbaord"),
          disabled: false,
          to: "/",
        },
        {
          text: this.$t("inventoryObj.myEquipment"),
          disabled: true,
          to: "breadcrumbs_link_1",
        },
      ],
      allSelectedHeaders: [
        "Display Name",
        "Farm/Zone",
        "Category",
        "Activity/Activities",
        "Equipment",
        "Identification/Chasis #",
        "Actions",
      ],
      headers: [
        {
          text: this.$t("inventoryObj.displayName"),
          align: "start",
          sortable: true,
          value: "display_name",
          class: "black--text",
        },
        {
          text: this.$t("inventoryObj.farmZone"),
          align: "start",
          sortable: true,
          value: "userFarmData",
          class: "black--text",
        },
        {
          text: this.$t("inventoryObj.category"),
          value: "categoryData.name",
          class: "black--text",
        },
        {
          text: this.$t("inventoryObj.activities"),
          value: "activityData.name",
          sortable: false,
          class: "black--text",
        },
        {
          text: this.$t("inventoryObj.equipment"),
          value: "equipmentData.name",
          class: "black--text",
          sortable: false,
        },
        {
          text: this.$t("Identification/Chassis #"),
          value: "identification_number",
          class: "black--text",
          sortable: false,
        },
        // {
        //   text: this.$t("Serial #"),
        //   value: "serial_number",
        //   align: "center",
        //   sortable: false,
        //   class: "black--text",
        // },
        { text: this.$t("Actions"), value: "actions", sortable: false },
      ],
      snackbar: {},
      showDeleteEquipmentDialog: false,
      selectedItem: {},
      equipmentType: "Single",
      loading: false,
    };
  },
  async mounted() {
    this.startLoading();
    document.title = "My Equipment";
    this.tableHeaders = this.headers;
    this.selectedHeaders = this.allSelectedHeaders;
  },
  mixins: [loadingMixin],
  created() {
    if (this.$route.query.add) {
      this.snackbar = {
        status: true,
        text: "Equipment successfully created.",
        color: "primary",
      };
      this.loading = true;
      this.$apollo.queries.equipments.refetch();
      this.loading = false;
    }
  },

  watch: {
    tableOptions: {
      handler() {},
      deep: true,
    },
    tab: {
      handler() {
        this.startLoading();

        // setTimeout(() => {
        //   this.stopLoading(); // Hide loading indicator when loading is done
        // }, 2000); // Adjust the delay as needed
      },
    },
    // tab() {
    //   // Show loading indicator when tab changes
    //   this.startLoading();

    //   // Simulate loading delay (remove this in your actual implementation)
    //   setTimeout(() => {
    //     this.stopLoading(); // Hide loading indicator when loading is done
    //   }, 1000); // Adjust the delay as needed
    // },
  },
  components: {
    RegisterEquipment,
    DeleteEquipmentDialog,
  },
  computed: {},
  methods: {
    editEquipment(item) {
      this.$router.push({
        name: "EquipmentUpdate",
        params: {
          id: item.id,
        },
      });
    },
    onDeleteSuccess() {
      this.snackbar = {
        status: true,
        text: "Equipment successfully deleted.",
        color: "red",
      };
      this.loading = true;

      this.$apollo.queries.equipments.refetch();
      this.loading = false;
    },
    pageChange(t) {
      if (t) {
        this.tableOptions.page = this.tableOptions.page + 1;
        return;
      } else {
        this.tableOptions.page = this.tableOptions.page - 1;
        return;
      }
    },
    resetDefaut() {
      this.tableHeaders = this.headers;
      this.selectedHeaders = this.allSelectedHeaders;
      this.menu = false;
    },
    resetTableStructure() {
      this.startLoading();
      this.tableHeaders = this.headers.filter(header =>
        this.selectedHeaders.includes(header.text)
      );
      this.tableOptions.itemsPerPage =
        this.itemsPerPageOptions[this.itemsPerPageSlider];
      (this.customizeMenu = false),
        (this.customizeMenuAll = false),
        this.stopLoading();
    },
    async exportToPDF() {
      const element = document.querySelector(".v-data-table__wrapper");
      html2pdf(element, {
        margin: 0,
        filename: "MyInventory.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { dpi: 200, letterRendering: true },
        jsPDF: {
          unit: "in",
          format: "letter",
          orientation: "landscape",
          compress: false,
        },
      });
    },
    async printPDF() {
      const element = document.querySelector(".v-data-table__wrapper");
      const cloneEle = element.cloneNode(true);

      const lastHeaderColumn = cloneEle.querySelector(".v-data-table__wrapper table tr th:last-child");
      if (lastHeaderColumn) {
        lastHeaderColumn.style.display = "none";
      }

      // Hide the last column in the table data
      const lastDataColumn = cloneEle.querySelector(".v-data-table__wrapper table tr td:last-child");
      if (lastDataColumn) {
        const rows = cloneEle.querySelectorAll(".v-data-table__wrapper table tbody tr");
        rows.forEach((row) => {
          const lastCell = row.querySelector("td:last-child");
          if (lastCell) {
            lastCell.style.display = "none";
          }
          const cells = row.querySelector("td");
          cells.style.paddingLeft = '10px';
        });
      }
      console.log("printPDF");
      let opt = {
        margin: 1,
        filename: "MyInventory.pdf",
        image: { type: "jpeg", quality: 0.95 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: "in", format: "a4", orientation: "landscape" },
      };

      let worker = await html2pdf()
        .set(opt)
        .from(cloneEle)
        .toCanvas()
        .outputPdf("blob", "MyInventory.pdf");
      let file = new File([worker], "MyInventory.pdf", {
        type: "application/pdf",
      });
      console.log(file);
      var pdfUrl = await URL.createObjectURL(file);
      console.log(pdfUrl);
      await printJS({ printable: `${pdfUrl}`, type: "pdf", showModal: true });
    },
  },
  apollo: {
    equipments: {
      query() {
        return gql`
          query equipments(
            $queryData: GetQueryDataArgs!
            $equipmentType: String!
          ) {
            equipments(queryData: $queryData, equipmentType: $equipmentType) {
              rows {
                id
                display_name
                user_id {
                  id
                  firstName
                }
                userFarmData {
                  farm_id {
                    id
                    farmName
                  }
                }
                userSegmentData {
                  segment_id {
                    id
                    geofenceName
                  }
                }
                categoryData {
                  id
                  name
                }
                activityData {
                  id
                  name
                }
                equipmentData {
                  id
                  name
                }
                equipmentGroupData {
                  id
                  name
                }
                energy_consumption
                energyConsumptionUnitData {
                  id
                  unitType
                  unitTypeData {
                    id
                    name
                  }
                }
                identification_number
                serial_number
                model
                year_of_purchase
                year_of_manufacture
                modeOfOperationData {
                  id
                  name
                }
                fuel_type
                loan_status
                count
              }
              count
              totalCount
            }
          }
        `;
      },
      variables() {
        return {
          queryData: {
            page: this.tableOptions.page,
            limit: this.tableOptions.itemsPerPage,
            searchPhrase: this.search,
          },
          equipmentType: this.equipmentType,
        };
      },
      result({ data }) {
        this.stopLoading();
        // console.log(data)
        this.totalEquipments = data.equipments.totalCount;
        this.totalPages = Math.ceil(
          this.totalEquipments / this.tableOptions.itemsPerPage
        );
        this.from =
          (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage + 1;
        this.to =
          this.tableOptions.page * this.tableOptions.itemsPerPage -
          (this.tableOptions.itemsPerPage - data.equipments.count);
      },
      error(error) {
        this.stopLoading(); // Stop loading animation if it's running
        console.error("Apollo Error:", error);
      },
      fetchPolicy: "no-cache",
    },
  },
};
</script>

<style lang="scss" scoped></style>
